import React from 'react';
import { TabType } from '../hooks';

interface ProjectTabsProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
}

const ProjectTabs: React.FC<ProjectTabsProps> = ({ activeTab, onTabChange }) => {
  return (
    <div style={{ 
      display: 'flex', 
      flexWrap: 'wrap',
      borderBottom: '1px solid #dee2e6', 
      marginBottom: '2rem',
      backgroundColor: 'white',
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '8px',
      overflow: 'hidden'
    }}>
      <button 
        onClick={() => onTabChange('overview')}
        style={{ 
          padding: '1rem 1.5rem', 
          border: 'none', 
          background: activeTab === 'overview' ? '#f0f0f0' : 'white',
          borderBottom: activeTab === 'overview' ? '2px solid #1e1e1e' : 'none',
          fontWeight: activeTab === 'overview' ? 600 : 400,
          cursor: 'pointer'
        }}
      >
        Overview
      </button>
      <button 
        onClick={() => onTabChange('property')}
        style={{ 
          padding: '1rem 1.5rem', 
          border: 'none', 
          background: activeTab === 'property' ? '#f0f0f0' : 'white',
          borderBottom: activeTab === 'property' ? '2px solid #1e1e1e' : 'none',
          fontWeight: activeTab === 'property' ? 600 : 400,
          cursor: 'pointer'
        }}
      >
        Property Details
      </button>
      <button 
        onClick={() => onTabChange('competition')}
        style={{ 
          padding: '1rem 1.5rem', 
          border: 'none', 
          background: activeTab === 'competition' ? '#f0f0f0' : 'white',
          borderBottom: activeTab === 'competition' ? '2px solid #1e1e1e' : 'none',
          fontWeight: activeTab === 'competition' ? 600 : 400,
          cursor: 'pointer'
        }}
      >
        Competition
      </button>
      <button 
        onClick={() => onTabChange('business-intelligence')}
        style={{ 
          padding: '1rem 1.5rem', 
          border: 'none', 
          background: activeTab === 'business-intelligence' ? '#f0f0f0' : 'white',
          borderBottom: activeTab === 'business-intelligence' ? '2px solid #1e1e1e' : 'none',
          fontWeight: activeTab === 'business-intelligence' ? 600 : 400,
          cursor: 'pointer'
        }}
      >
        Business Intelligence
      </button>
      <button 
        onClick={() => onTabChange('members')}
        style={{ 
          padding: '1rem 1.5rem', 
          border: 'none', 
          background: activeTab === 'members' ? '#f0f0f0' : 'white',
          borderBottom: activeTab === 'members' ? '2px solid #1e1e1e' : 'none',
          fontWeight: activeTab === 'members' ? 600 : 400,
          cursor: 'pointer'
        }}
      >
        Members
      </button>
      <button 
        onClick={() => onTabChange('reports')}
        style={{ 
          padding: '1rem 1.5rem', 
          border: 'none', 
          background: activeTab === 'reports' ? '#f0f0f0' : 'white',
          borderBottom: activeTab === 'reports' ? '2px solid #1e1e1e' : 'none',
          fontWeight: activeTab === 'reports' ? 600 : 400,
          cursor: 'pointer'
        }}
      >
        Reports
      </button>
    </div>
  );
};

export default ProjectTabs;
